import type { ImagePromptWithSize } from '@/app/types';

export const getImageRatio = (image: ImagePromptWithSize) => {
  // 如果选中了图片的一部分，则计算选中的部分宽高比

  if (image.selectedImageRange) {
    const [x1, y1, x2, y2] = image.selectedImageRange;
    return (x2 - x1) / (y2 - y1);
  }
  // 如果未选中图片的一部分，则计算整张图片的宽高比

  return image.sourceImageWidth / image.sourceImageHeight;
};
